// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t5-0";
export var checkoutRateBadgeLink = "_t5-1";